// src/services/api/users.js
import { apiClient } from './base';

// User Management
export const createUser = async (userData) => {
  try {
    const response = await apiClient.post('/users', userData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUsers = async (params = {}) => {
  try {
    const response = await apiClient.get('/users', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUser = async (userId) => {
  try {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await apiClient.put(`/users/${userId}`, userData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserStatus = async (userId, status) => {
  try {
    const response = await apiClient.patch(`/users/${userId}/status`, { status });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetUserPassword = async (userId) => {
  try {
    const response = await apiClient.post(`/users/${userId}/reset-password`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// User Role Management
export const createUserRole = async (roleData) => {
  try {
    const response = await apiClient.post('/user-roles', roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserRoles = async (params = {}) => {
  try {
    const response = await apiClient.get('/user-roles', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserRole = async (roleId) => {
  try {
    const response = await apiClient.get(`/user-roles/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateUserRole = async (roleId, roleData) => {
  try {
    const response = await apiClient.put(`/user-roles/${roleId}`, roleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserRole = async (roleId) => {
  try {
    const response = await apiClient.delete(`/user-roles/${roleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const duplicateUserRole = async (roleId) => {
  try {
    const response = await apiClient.post(`/user-roles/${roleId}/duplicate`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Email validation
export const checkEmailAvailability = async (email, userId = null) => {
  try {
    const params = { email };
    if (userId) {
      params.userId = userId;
    }
    const response = await apiClient.get('/users/check-email', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};